/* eslint-disable no-undef, no-underscore-dangle, no-param-reassign */
import { getAppointmentTypes } from '@/services/appointment';
import {
  GET_APPOINTMENT_TYPES_SUCCESS,
  LOADING,
  LOADING_SUCCESS,
  CLEAR_APPOINTMENT_TYPES,
  // CLIENT_FETCHED,
} from './mutation-types';

const appointmentTypes = {
  state: {
    list: [],
  },
  mutations: {
    [GET_APPOINTMENT_TYPES_SUCCESS](state, types) {
      state.list = types;
    },
    [CLEAR_APPOINTMENT_TYPES](state) {
      state.list = [];
    },
  },
  actions: {
    clearAppointmentTypes({ commit }) {
      commit(CLEAR_APPOINTMENT_TYPES);
    },
    getAppointmentTypes({ commit, state }) {
      return new Promise((resolve, reject) => {
        if (state.list.length !== 0) {
          return resolve(state.list);
        }
        commit(LOADING);
        return getAppointmentTypes()
          .then((res) => {
            const { data } = res;
            if (!data || data.appointment_types.length === 0) {
              const noAppTypeError = new Error('Could not fetch appointment types');
              return reject(noAppTypeError);
            }
            commit(GET_APPOINTMENT_TYPES_SUCCESS, data.appointment_types);
            commit(LOADING_SUCCESS);
            return resolve(data.appointment_types);
          })
          .catch((err) => {
            commit(LOADING_SUCCESS);
            reject(err);
          });
      });
    },
  },
};

export default appointmentTypes;



// WEBPACK FOOTER //
// ./src/store/appointment-types.js